import {addAlert} from "../containers/App/actions";
import moment from "moment-timezone";


export function addAuthorizationHeader(config, getState) {
    return {
        ...config,
        headers: {'Authorization': getState().auth.token}
    };
}

export function addTimeZoneHeader(config) {
    if (!config.headers) {
        config.headers = {};
    }
    config.headers['TZ'] = moment.tz.guess();
    return config;
}

const formatErrorValue = value => {
    if (typeof value === 'string') {
        return value;
    }

    if (Array.isArray(value)) {
        return value.flat().map(obj => obj?.email || obj).join(', ');
    }

    if (value && typeof value === 'object') {
        return value.message || value.type || JSON.stringify(value);
    }

    return value;
};

export const apiCall = (message, config, fn, dispatch, getState, showSuccessMessage = true, callback = null) => {
    if (getState) {
        if (config.constructor.name === "Array") {
            config = config.map(c => addAuthorizationHeader(c, getState));
        } else {
            config = addAuthorizationHeader(config, getState);
        }
    }
    config = addTimeZoneHeader(config);
    return fn(config).then(() => {
        if (showSuccessMessage) {
            dispatch(
                addAlert({
                    message: `${message} succeed`,
                    mood: "success",
                    dismissAfter: 1500,
                })
            );
        }
    }).catch(exception => {
        const responseData = exception?.response?.data;
        const showValidationErrors = typeof responseData === 'object';
        let errors = exception.toString();
        if (showValidationErrors) {
            errors = responseData?.message || Object.keys(responseData)
                .map(key => key + ': ' + formatErrorValue(responseData[key]))
                .join('   ');
        }
        dispatch(
            addAlert({
                message: `${message} failed with ${errors}`,
            }),
            callback && callback(exception.response)
        );
        throw exception
    })
};

